

/**
 * @readonly
 * @enum {string}
 */
export const inputTypes = {
    INPUTFIELD: "inputField",
    SELECTFIELD: "selectField",
}